/* eslint-disable */
import { Component } from "react";
import { RendererProvider } from "react-fela";
import { createRenderer } from "~/modules/renderer";

const fallbackRenderer = createRenderer();

export default class FelaProvider extends Component {
  render() {
    const renderer = this.props.renderer || fallbackRenderer;
    return (
      <RendererProvider renderer={renderer}>
        {this.props.children}
      </RendererProvider>
    );
  }
}
